module.exports = __webpack_public_path__ + "static/media/holly-michaels-icon.fb15c84f.jpg";